import type { CurrencyEnum, Maybe } from '~~/lib/Shop/generated/schema';
import { getCurrencySymbolOverride } from '~/utils/shop/currencySymbolOverrides';

export function formatCurrency(
  value: number,
  currency?: string | null,
  locale = 'en-us',
  withCurrency = true
): string {
  if (!currency) {
    return `${value}`;
  }

  try {
    const styling = {
      style: 'currency',
      currency
    } as Intl.NumberFormatOptions;
    const formatter = new Intl.NumberFormat(locale, styling);
    const resolvedOptions = formatter.resolvedOptions();

    if (withCurrency) {
      const symbolOverride = getCurrencySymbolOverride(currency);

      if (symbolOverride) {
        return formatter
          .formatToParts(value)
          .map((part) =>
            part.type === 'currency' ? symbolOverride : part.value
          )
          .join('');
      }

      return formatter.format(value);
    }

    // Der Style muss entfernt werden, ansonsten wird das CurrencySign ausgegeben
    return value.toLocaleString(locale, {
      ...resolvedOptions,
      style: undefined
    });
  } catch (_e) {
    // XXX: ignored for now
  }

  return withCurrency ? `${value} ${currency}` : `${value}`;
}

export type OptionalMoneyFragment = {
  currency?: Maybe<CurrencyEnum> | null | undefined;
  value?: Maybe<number> | null | undefined;
};

// We cannot use type MoneyFragment here for parameter money because MoneyFragment's values can be undefined in other queries -.-
export function formatMoney(
  money?: OptionalMoneyFragment | null,
  locale = 'en-us',
  withCurrency = true
): string {
  if (!money || money.value == null) {
    return '';
  }

  const { currency, value } = money;

  return formatCurrency(value, currency, locale, withCurrency);
}
